import {useDebugValue} from 'react';

import {useSearchFormContext} from './useSearchFormContext';

function useSearchFormContextProvider(props) {
    const value = useSearchFormContext(props);

    const result = {
        value
    };

    useDebugValue(result);

    return result;
}

export {useSearchFormContextProvider};
